module.exports = __webpack_public_path__ + "img/dreamer.66012c38.jpg";